// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'field-dot';

export const Component = () => (
  <>
    <path d='M22 16.5v1H3v-1zm1-1v-6a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1v1l-.204-.01a2 2 0 0 1-1.785-1.786L1 15.5v-6a2 2 0 0 1 1.796-1.99L3 7.5h19l.204.01A2 2 0 0 1 24 9.5v6l-.01.204a2 2 0 0 1-1.786 1.785L22 17.5v-1a1 1 0 0 0 1-1z' />
    <circle cx='6' cy='12.5' r='2' fill='currentColor' />
  </>
);

export const viewBox = '0 0 25 25';
